<template>
  <div v-if="blok.active" v-editable="blok">
    <div v-if="preTextContent" class="cms-text" v-html="preTextContent" />
    <div
      class="divide-gray-300 divide-y"
      :class="[marginClasses, maxWidthClasses]"
    >
      <component
        :is="entry.component"
        v-for="entry in visibleEntries"
        :key="entry._uid"
        :blok="entry"
        :heading-level="blok.heading_level || 'normal'"
        :uppercase-title="blok.uppercase_title === true"
        :bold-title="blok.bold_title === true"
        :show-arrows="blok.show_arrows === true"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import useRichtext from '~/cms/storyblok/composables/useRichtext'
import useStoryblokMargins from '~/cms/storyblok/composables/useStoryblokMargins'
import type { SbAccordion } from '~/cms/storyblok/types/storyblok.d.ts'

const { blok } = defineProps<{ blok: SbAccordion }>()

const { content: preTextContent } = useRichtext(blok.preText)

const visibleEntries = computed(() =>
  (blok.entries ?? []).filter(
    (entry) =>
      entry.body?.content &&
      Array.isArray(entry.body.content) &&
      entry.body.content.length > 0,
  ),
)

const { marginClasses } = useStoryblokMargins(blok)

const maxWidthClasses = computed(() => {
  const width = blok.max_width
  const alignment = blok.alignment

  // If no max width is set, return empty string
  if (!width) {
    return ''
  }

  const widthClass = `max-w-${width}`

  const alignmentMap = {
    left: 'mr-auto',
    center: 'mx-auto',
    right: 'ml-auto',
  }
  const alignmentClass =
    alignmentMap[alignment as keyof typeof alignmentMap] || 'mr-auto'

  return `${widthClass} ${alignmentClass}`
})
</script>
